(() => {
  const ready = (callback) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', callback, { once: true })
      : callback();

  const money = (value) => {
    if (!value) return '';
    const amount = Number.parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    if (!Number.isFinite(amount)) return String(value);

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP',
      }).format(amount);
    } catch {
      return `£${amount.toFixed(2)}`;
    }
  };

  const getForms = () =>
    Array.from(
      new Set([
        ...document.querySelectorAll('.bx-search-form'),
        ...document.querySelectorAll('predictive-search form[role="search"]'),
      ]),
    );

  let resultId = document.querySelectorAll('[id^="BronxPredictiveResults-"]').length;

  function initialiseForm(form) {
    const input = form.querySelector('input[type="search"]');
    if (!input || form.dataset.bxPredictiveReady === 'true') return;

    form.dataset.bxPredictiveReady = 'true';
    form.classList.add('bx-search-form');

    const legacyResults = form.querySelector('[data-predictive-search]');
    if (legacyResults) legacyResults.hidden = true;

    const results = document.createElement('div');
    results.className = 'bx-predictive-results';
    results.id = `BronxPredictiveResults-${++resultId}`;
    results.setAttribute('role', 'listbox');
    results.hidden = true;
    form.appendChild(results);

    input.setAttribute('aria-controls', results.id);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    let controller;
    let timer;

    const close = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const render = (products, query) => {
      results.replaceChildren();

      const heading = document.createElement('div');
      heading.className = 'bx-predictive-results__heading';
      heading.textContent = products.length ? 'Suggested products' : 'No products found';
      results.appendChild(heading);

      products.forEach((product) => {
        const link = document.createElement('a');
        link.className = 'bx-predictive-result';
        link.href = product.url;
        link.setAttribute('role', 'option');

        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = '';
          image.width = 88;
          image.height = 110;
          link.appendChild(image);
        }

        const copy = document.createElement('span');
        copy.className = 'bx-predictive-result__copy';

        const title = document.createElement('strong');
        title.textContent = product.title;

        const price = document.createElement('span');
        price.textContent = money(product.price);

        copy.append(title, price);
        link.appendChild(copy);
        results.appendChild(link);
      });

      const all = document.createElement('a');
      all.className = 'bx-predictive-results__all';
      all.href = `/search?q=${encodeURIComponent(query)}&options[prefix]=last`;
      all.textContent = `View all results for “${query}” →`;
      results.appendChild(all);

      open();
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();

      if (query.length < 2) {
        controller?.abort();
        close();
        return;
      }

      timer = window.setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();

        try {
          const params = new URLSearchParams({
            q: query,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
          });

          const response = await fetch(
            `${window.routes?.predictive_search_url || '/search/suggest'}.json?${params}`,
            {
              signal: controller.signal,
              headers: { Accept: 'application/json' },
            },
          );

          if (!response.ok) throw new Error('Search failed');

          const data = await response.json();
          render(data?.resources?.results?.products || [], query);
        } catch (error) {
          if (error.name !== 'AbortError') close();
        }
      }, 180);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'ArrowDown' || results.hidden) return;

      const first = results.querySelector('a');
      if (first) {
        event.preventDefault();
        first.focus();
      }
    });

    results.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) return;

      if (event.key === 'Escape') {
        close();
        input.focus();
        return;
      }

      const links = Array.from(results.querySelectorAll('a'));
      const currentIndex = links.indexOf(document.activeElement);
      if (currentIndex < 0) return;

      event.preventDefault();
      const nextIndex =
        event.key === 'ArrowDown'
          ? Math.min(links.length - 1, currentIndex + 1)
          : Math.max(0, currentIndex - 1);

      links[nextIndex].focus();
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) close();
    });
  }

  function initialise() {
    getForms().forEach(initialiseForm);
  }

  ready(initialise);
  document.addEventListener('shopify:section:load', initialise);
})();
